import invitations from "../../../shared/invitations";
import { CLEAR_REGISTERED, REGISTER_GET_CURRENCIES, REGISTER_GET_LANGUAGES } from "./actions";
import { v4 as uuidv4 } from 'uuid';

interface RegisterState {
  loadingRegister: boolean;
  loadingLanguages: boolean;
  loadingCountries: boolean;
  loadingCurrencies: boolean;
  user: any;
  countries: any[];
  languages: any[];
  currencies: any[];
  defaultCountryId: any;
  defaultLanguageId: any;
  defaultCurrencyId: any;
  referralCode: string | null;
  ref: any;
  registering: boolean;
  errors: any;
}

const defaultState: RegisterState = {
  loadingRegister: false,
  loadingLanguages: false,
  loadingCountries: false,
  loadingCurrencies: false,
  user: {},
  countries: [],
  languages: [],
  currencies: [],
  defaultCountryId: null,
  defaultLanguageId: null,
  defaultCurrencyId: null,
  referralCode: null,
  ref: null,
  registering: false,
  errors: null
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case "REGISTER_CLEAR_FORM": {
      // const referralCode = invitations.getReferralCode();
      // const ref = localStorage.getItem("ref");
      // const user = { referrer: ref };      
      const emailAddress = uuidv4().replace(/-/g, "") + "@filmtools.co.uk";
      return {
        ...state,
        //user: user,
        //user: { firstName: "Test", lastName: "User", emailAddress: emailAddress, password: "Password123~", confirmPassword: "Password123~", referrer: "Me", agree: true },
        errors: null,
        registered: false,
        //referralCode,
        //ref
      };
    }

    case "REGISTER_GET_COUNTRIES_PENDING": {
      return {
        ...state,
        loadingCountries: true
      };
    }

    case "REGISTER_GET_COUNTRIES_FULFILLED": {
      return {
        ...state,
        countries: action.payload.data.countries,
        user: { ...state.user, countryId: action.payload.data.defaultId },
        defaultCountryId: action.payload.data.defaultId,
        loadingCountries: false
      };
    }

    case "REGISTER_GET_COUNTRIES_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loadingCountries: false
      };
    }

    case REGISTER_GET_LANGUAGES + "_PENDING": {
      return {
        ...state,
        loadingLanguages: true
      };
    }

    case REGISTER_GET_LANGUAGES + "_FULFILLED": {
      return {
        ...state,
        languages: action.payload.data.languages,
        user: { ...state.user, languageId: action.payload.data.defaultId },
        defaultLanguageId: action.payload.data.defaultId,
        loadingLanguages: false
      };
    }

    case REGISTER_GET_LANGUAGES + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loadingLanguages: false
      };
    }

    case REGISTER_GET_CURRENCIES + "_PENDING": {
      return {
        ...state,
        loadingCurrencies: true
      };
    }


    case REGISTER_GET_CURRENCIES + "_FULFILLED": {
      return {
        ...state,
        currencies: action.payload.data.currencies,
        user: { ...state.user, currencyId: action.payload.data.defaultId },
        defaultCurrencyId: action.payload.data.defaultId,
        loadingCurrencies: false
      };
    }

    case REGISTER_GET_CURRENCIES + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loadingCurrencies: false
      };
    }

    case "REGISTER_PENDING": {
      return {
        ...state,
        registering: true,
        errors: null
      };
    }

    case "REGISTER_FULFILLED": {
      localStorage.removeItem("ref");
      //localStorage.setItem("userId", action.payload.data.userId);
      localStorage.setItem("currencyId", action.payload.data.currencyId);
      //localStorage.setItem("userEmailAddress", action.meta.user.emailAddress);
      //localStorage.setItem("userName", action.payload.data.name);
      return {
        ...state,
        registering: false,
        errors: null,
        registered: true
      };
    }

    case "REGISTER_REJECTED": {
      let referralCode = state.referralCode;
      if (action.payload.response.data.invalidReferralCode) {
        invitations.removeReferralCode();
        referralCode = null;
      }

      return {
        ...state,
        user: action.meta.user,
        errors: action.payload.response.data.errors,
        registering: false,
        referralCode: referralCode
      };
    }

    case "CLEAR_REGISTER_REDIRECT": {
      return {
        ...state,
        redirect: null
      };
    }

    case CLEAR_REGISTERED: {
      return {
        ...state,
        registered: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
